import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './quasar'
import { apolloProvider } from './vue-apollo'
import moment from 'moment'
import { NetworkCommunicator } from './plugins/NetworkResourceHandler'
import Constants from './Constants/Constant'
import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
  id: 'UA-157711785-1',
  router,
  debug: {
    sendHitTask: process.env.NODE_ENV == 'production',
  },
})
Vue.config.productionTip = false
Vue.config.errorHandler = function (err, vm, info) {
  let msg = `[Global Error Handler]: Error in ${info} : ${err}`
  let data = {
    data: {
      errorMessage: msg,
    },
  }
  NetworkCommunicator('POST', Constants.api_url + 'addConsoleError', false,
    data).then(response => {
    console.log('Vue Error Logged')
  })
}
window.onerror = function (message, source, line, column, error) {
  let data = {
    data: {
      message: message,
      source: source,
      lineno: line,
      colno: column,
      error: error,
    },
  }
  if (message !== 'ResizeObserver loop limit exceeded') {
    NetworkCommunicator('POST', Constants.api_url + 'addConsoleError', false,
      data).then(response => {
      console.log('Console Error Logged')
    })
  }
}

Vue.filter('dateFilter', function (val) {
  return val ? moment(val, 'YYYY-MM-DD').format('DD/MM/YYYY') : '-'
})
Vue.filter('monthFilter', function (val) {
  return val ? moment(val, 'YYYY-MM-DD').format('MMM YYYY') : '-'
})
Vue.filter('currencyFilter', function (val) {
  return ![null, undefined].includes(val) ? val.toLocaleString('en-IN', { minimumFractionDigits:0, style: 'currency', currency: 'INR' }).replace(/₹/g, '₹') : '₹0'
})

Vue.mixin({
  methods: {
    'timeFromFilter': function (val) {
      return val ? moment(moment.unix(Number(val))).fromNow() : '-'
    },
    'dateTimeFilter': function (val) {
      return val ? moment(val).
        format('DD/MM/YYYY hh:mm A') : '-'
    },
    'dateFilter': function (val) {
      return val ? moment(val).format('DD/MM/YYYY') : '-'
    },
    'dateMonthFilter': function (val) {
      return val ? moment(val).format('DD MMM YYYY') : '-'
    },
    'timestampFilter' (val) {
      return val ? moment.unix(val).
        format('DD/MM/YYYY hh:mm A') : '-'
    },
    'monthFilter' (val) {
      return val ? moment(val, 'YYYY-MM-DD').format('MMM YYYY') : '-'
    },
    'dynamicDateFormatter' (val, fromFormat, toFormat) {
      return val ? moment(val, fromFormat).format(toFormat) : '-'
    },
    'toLower' (val) {
      return val ? val.toString().toLowerCase() : '-'
    },
    checkVal (val) {return val ? val : (typeof val === 'number' ? val : '-')},
    getSchemePoints (schemePoints, specialSchemeId) {
      let points = []
      schemePoints.forEach((schemePoint) => {
        if (schemePoint.schemeId === specialSchemeId) {
          points[0] = schemePoint.earnPoint ? schemePoint.earnPoint +
            schemePoint.myTeamEarnPoint : 0
          points[1] = schemePoint.eligiblePoint ? schemePoint.eligiblePoint +
            schemePoint.myTeamEligiblePoint -
            schemePoint.earnPoint - schemePoint.myTeamEarnPoint : 0
        }
      })
      return (points[0] ? points[0] : 0) + (' / ') + (points[1] ? points[1] : 0)
    },
    'calculateEligiblePoints' (obj, flag) {
      if (obj) {
        if (flag)
          return obj.eligiblePoint + obj.myTeamEligiblePoint - obj.earnPoint -
            obj.myTeamEarnPoint
        else return obj.eligiblePoint - obj.earnPoint
      } else return 0
    },
    'calculateEligiblePointsMonthly' (obj, flag) {
      if (obj) {
        if (flag)
          return obj.eligiblePoint + obj.myTeamEligiblePoint + obj.adjustment
        else return obj.eligiblePoint + obj.adjustment
      } else return 0
    },
    'calculateClosingPoints' (enrolObj, schemeDetail) {
      let closingPoints = 0
      if (enrolObj && schemeDetail) {
        if (enrolObj && schemeDetail && schemeDetail.isHerirachyScheme) {
          closingPoints = enrolObj.earnPoint + enrolObj.myTeamEarnPoint -
            enrolObj.redemPoint
            - enrolObj.redemptioInProgress - enrolObj.transferPoints -
            enrolObj.returnOrderPoint
        } else if (enrolObj && schemeDetail &&
          !schemeDetail.isHerirachyScheme) {
          closingPoints = enrolObj.earnPoint - enrolObj.redemPoint -
            enrolObj.redemptioInProgress - enrolObj.transferPoints -
            enrolObj.returnOrderPoint
        }
        return enrolObj ? enrolObj.adjustment + closingPoints : closingPoints
      } else {
        return 0
      }
    },
    'calculateTotalPoints' (enrolObj, schemeDetail) {
      let totalPoints = 0
      if (enrolObj && schemeDetail) {
        if (enrolObj && schemeDetail && schemeDetail.isHerirachyScheme) {
          totalPoints = enrolObj.eligiblePoint + enrolObj.myTeamEligiblePoint -
            enrolObj.transferPoints - enrolObj.returnOrderPoint
        } else if (enrolObj && schemeDetail &&
          !schemeDetail.isHerirachyScheme) {
          totalPoints = enrolObj.eligiblePoint - enrolObj.transferPoints -
            enrolObj.returnOrderPoint
        }
        return enrolObj ? enrolObj.adjustment + totalPoints : totalPoints
      } else {
        return 0
      }
    },
    formatCurrency (val) {
      return (val).toLocaleString('en-IN',
        { style: 'currency', currency: 'INR' })
    },
  },
})

Vue.filter('titleize', function (string) {
  return string
    ? string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
    : ''
})

String.prototype.toSentenceCase = function () {
  return this.replace(
    /\w\S*/g,
    function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    },
  )
}

Object.defineProperty(Object, "copyExistingKeys", {
  value: (target, source) => {
    'use strict';
    if(target === null || target === undefined) {
      throw new TypeError('Cannot convert undefined or null to object');
    }
    Object.keys(target).forEach(key => {
      if (key in source) target[key] = source[key];
    });
  },
  writable: true,
  configurable: true,
});

function limit (c) {
  return this.filter((x, i) => {
    if (i <= (c - 1)) {return true}
  })
}

function skip (c) {
  return this.filter((x, i) => {
    if (i > (c - 1)) {return true}
  })
}

Array.prototype.skip = skip
Array.prototype.limit = limit

Vue.prototype.$allNotifications = []
Vue.prototype.$totalNotificationCount = 0
Vue.prototype.$unreadNotifications = []
Vue.prototype.$slicedNotifications = []
Vue.prototype.$notificationSkip = 0
Vue.prototype.$notificationLimit = Constants.notificationLimitPerBatch

new Vue({
  router,
  store,
  apolloProvider,
  render: h => h(App),
}).$mount('#app')
